'use client';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

import { EXIT_DELAY_IN_SECONDS } from './settings';
import { usePageTransition } from './Transitions';

interface AnimateProps {
  children: React.ReactNode;
  className?: string;
}

const Animate = ({ children, className }: AnimateProps) => {
  const { pending } = usePageTransition();

  return (
    <AnimatePresence mode="wait">
      {!pending && (
        <motion.div
          exit={{ x: 0 }}
          transition={{ duration: EXIT_DELAY_IN_SECONDS }}
          className={className}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Animate;
